export default "/images/gradiant-logo.png?e87d0eaf6eb2a9f55643f838404833cd";